<template>
  <main class="l-main">
    <div class="l-error c-card">
      <div class="l-error__inner-red">
        <div class="l-error__message l-error__message--red">
          <span>
            <IconAlert />
          </span>
          <p>
            お使いのアカウントはご利用いただけません。
          </p>
        </div>

        <div class="l-error__btn">
          <div class="c-buttonWrap4">
            <ButtonLink
              tag="a"
              :href="redirectUrl"
              style-type="primary"
              color="color2"
            >
              ログイン
            </ButtonLink>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import Cookies from "js-cookie";
import ButtonLink from "@/common/components/atoms/ButtonLink.vue";
import IconAlert from "@/common/components/icons/IconAlert.vue";
import meta from "@/general/store/modules/meta";
import auth from "@/general/store/modules/auth";
import AuthStorage from "@/general/utils/auth";

@Options({
  props: {
    error: { type: Boolean, required: false, default: false }
  },
  components: {
    ButtonLink,
    IconAlert
  }
})
export default class ErrorAuth extends Vue {
  error!: boolean;

  get redirectUrl() {
    // 戻り先 url の設定が必要
    return (
      process.env.VUE_APP_AUTH_FACADE +
      "?callback_authorization_start_uri=" +
      process.env.VUE_APP_API_DOMAIN +
      "/v1/top/auth-start"
    );
  }
  get title() {
    const metaTitle = process.env.VUE_APP_PAGE_TITLE;
    return metaTitle;
  }

  get currentHref() {
    return window.location.href;
  }
  async mounted() {
    await meta.setDocumentTitle("お使いのアカウントはご利用いただけません。");
  }
}
</script>

<style lang="scss" scoped></style>
